import React, { useState, useEffect } from "react";
import { useSelector, connect } from "react-redux";
import { useHistory, Link } from "react-router-dom";
import {
  Paper,
  TextField,
  Button,
  FormControl,
  Grid,
} from "@material-ui/core";
import { ROLENAME, salesDepartment } from "../../utils/index";
import {
  Table,
  TableBody,
  TableCell,
  TableRow,
} from "@material-ui/core";
import moment from "moment";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import HttpService from "../../services/httpService";
import { setUserDetails } from "../../redux/actions/userAction";
import { setLoading, setSnackInfo } from "../../redux/actions/appAction";
import Autocomplete from "@material-ui/lab/Autocomplete";
import SalesUserLeadMetricsTable from "../../components/SalesUserLeadMetricsTable";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing(2),
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    width: 200,
  },
}));

const Index = (props) => {
  const classes = useStyles();
  const { userDetails } = useSelector((state) => state.user);
  const [startDate, setStartDate] = useState(
    userDetails.selectedStartDate
      ? userDetails.selectedStartDate
      : moment().subtract(1, "months").format("YYYY-MM-DD")
  );
  const [endDate, setEndDate] = useState(
    userDetails.selectedEndDate
      ? userDetails.selectedEndDate
      : moment().add(1, "days").format("YYYY-MM-DD")
  );
  const [expcenters, setExpcenters] = useState([]);
  const [defaultExpCenter, setDefaultExpCenter] = useState(
    userDetails.selectedExpCenter
  );
  const [defaultCity, setDefaultCity] = useState(userDetails.selectedLocation);
  const [cities, setCities] = useState([]);
  const [defaultExpCenterId, setDefaultExpCenterId] = useState(
    userDetails.selectedExpCenter
  );
  const [defaultCityId, setDefaultCityId] = useState(
    userDetails.selectedLocation
  );
  const [selectedLocationDashboard, setSelectedLocationDashboard] = useState();
  const [selectedFilterOption, setSelectedFilterOption] = useState(
    userDetails.selectedFilterOption
      ? userDetails.selectedFilterOption
      : "createdAt"
  );
  const [commonExpCenter, setExpCenter] = useState([]);
  const [selectedExperienceCenter, setSelectedExperienceCenter] = useState([]);
  const [salesData, setSalesData] = useState([]);
  const [locationExpCenters, setLocationExpCenters] = useState([]);

  useEffect(() => {
    getLocationList();
    expCenters();
    if (
      userDetails?.roles?.find(
        (role) =>
          role.name === ROLENAME.SalesUser
      )
    ) {
      getSalesData(selectedExperienceCenter);
    }
  }, [userDetails]);

  const getSalesData = async (expCenters) => {
    const ids = expCenters?.map((item) => item._id);
    props.setSnackInfo("Data Loading, please wait...", "info");
    props.setLoading(true);

    let data = {
      startDate: startDate,
      endDate: endDate,
      experienceCenterId: userDetails.roles.find(
        (role) =>
          role.name === ROLENAME.SalesHead || role.name === ROLENAME.DGM_Sales
      )
        ? ids.length !== 0
          ? ids
          : []
        : ids.length !== 0
        ? ids
        : defaultExpCenterId,
      filterOption: selectedFilterOption,
    };

    try {
      // Make the API request
      const response = await HttpService.getSalesLeadOnSelectedDate(data);
      if (response.status === 200) {
        setSalesData(response.data);
        props.setSnackInfo("Data Loaded Successfully", "success");
      }
    } catch (error) {
      console.error(error, "error");
      props.setSnackInfo("Error Loading Data", "error");
    } finally {
      props.setLoading(false);
    }
  };

  const getLocationList = async () => {
    props.setLoading(true);
    try {
      const response = await HttpService.getLocationList();
      let userLocation = [];
        for (let i = 0; i < response.data.length; i++) {
          for (let j = 0; j < userDetails.locationId.length; j++) {
            if (response.data[i]._id === userDetails.locationId[j]._id) {
              userLocation.push({
                _id: userDetails.locationId[j]._id,
                name: userDetails.locationId[j].name,
              });
            }
          }
        }
        setCities(userLocation);
      const ddd = userLocation.filter(
        (ele) => ele._id === userDetails.selectedLocation
      );
      setDefaultCity(ddd[0]["name"]);
      setDefaultCityId(ddd[0]["_id"]);
      setSelectedLocationDashboard(ddd[0]["_id"]);
      getExperienceCenterByLocation(ddd[0]["_id"]);
    } catch (error) {
      console.log(error);
    }
    props.setLoading(false);
  };

  const getExperienceCenterByLocation = async (locid) => {
    props.setLoading(true);
    try {
      const response = await HttpService.getExpericenCentersByLocation(locid);
      let userExpCenters = [];
      for (let i = 0; i < response.data.length; i++) {
        for (let j = 0; j < userDetails.experienceCenterId.length; j++) {
          if (userDetails.experienceCenterId[j] === response.data[i]["_id"]) {
            userExpCenters.push({
              name: response.data[i]["name"],
              _id: response.data[i]["_id"],
            });
          }
        }
      }
      setLocationExpCenters(response.data);
      setExpcenters(userExpCenters);
      const finalselected = userExpCenters.filter(
        (ele) => ele._id === userDetails.selectedExpCenter
      );
      setDefaultExpCenter(finalselected[0]["name"]);
      setDefaultExpCenterId(finalselected[0]["_id"]);
    } catch (error) {
      console.log(error);
    }
    props.setLoading(false);
  };

  const [dates, setDates] = useState({
    start: startDate,
    end: endDate,
  });

  const expCenters = async () => {
    props.setLoading(true);
    try {
      let response = await HttpService.getExpericenCenters();
      const matchedUsers = response.data.filter((user) => {
        return userDetails.experienceCenterId.includes(user._id);
      });
      setExpCenter(matchedUsers);
    } catch (error) {
      console.error("Error fetching experience centers:", error);
      props.setSnackInfo(
        error?.response?.data ?? "Something Went Wrong",
        "error"
      );
    }
    props.setLoading(false);
  };

  const getLeadsOnSelectedDateByRole = () => {
    setDates({
      start: startDate,
      end: endDate,
    });
    props.setUserDetails({
      ...userDetails,
      selectedStartDate: startDate,
      selectedEndDate: endDate,
      selectedFilterOption: selectedFilterOption,
    });
    if (
      userDetails?.roles?.find(
        (role) =>
          role.name === ROLENAME.SalesUser 
      )
    ) {
      getSalesData(selectedExperienceCenter);
    }
  };

//   const clearFilterDate = () => {
//     setStartDate(moment().subtract(1, "months").format("YYYY-MM-DD"));
//     setEndDate(moment().add(1, "days").format("YYYY-MM-DD"));
//     setDates({
//       start: moment().subtract(1, "months").format("YYYY-MM-DD"),
//       end: moment().add(1, "days").format("YYYY-MM-DD"),
//     });
//   };

  return (
    <div>
      <Paper
        className={classes.paper}
        style={{ marginBottom: 20, marginTop: 20 }}
      >
        {userDetails.departmentId === salesDepartment && (
          <FormControl component="fieldset" style={{ marginBottom: 20 }}>
            <div style={{ marginLeft: 10 }}>Lead Created At</div>
          </FormControl>
        )}
        <br />
        <Grid container>
          <Grid item md={3} xs={12}>
            <TextField
              id="date"
              name="startDate"
              label="From Date"
              type="date"
              value={startDate}
              onChange={(e) => setStartDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              className={classes.textField}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <TextField
              id="date"
              name="endDate"
              label="End Date"
              type="date"
              value={endDate}
              onChange={(e) => setEndDate(e.target.value)}
              InputLabelProps={{
                shrink: true,
              }}
              fullWidth
              className={classes.textField}
            />
          </Grid>
          <Grid item md={3} xs={12}>
            <Button
              variant="contained"
              color="primary"
              disabled={!startDate || !endDate}
              onClick={getLeadsOnSelectedDateByRole}
            >
              Submit
            </Button>
          </Grid>
          {/* <Grid item md={2} xs={12}>
            <Button
              variant="contained"
              color="secondary"
              onClick={clearFilterDate}
            >
              Clear Filter
            </Button>
          </Grid> */}
        </Grid>
      </Paper>

      {cities.length !== 0 ? (
        <SalesUserLeadMetricsTable
          role={userDetails.roles[0]["name"]}
          company={"Decorpot"}
          selecteddate={dates}
          selectedexpcenter={defaultExpCenter}
          selectedexpcenterid={defaultExpCenterId}
          selectedlocationid={defaultCityId}
          selectedLocation={selectedLocationDashboard}
          salesdata={salesData}
          filteroption={selectedFilterOption}
        />
      ) : null}
    </div>
  );
};
export default connect(null, { setUserDetails, setLoading, setSnackInfo })(Index);
